<template>
  <div>
    <basic-container>
      <avue-crud class="crud-search-pad" :option="tableOption" :data="tableData" :table-loading="tableLoading"
        :page="page" ref="crud" @search-change="searchChange" @search-reset="searchReset"
        @refresh-change="refreshChange" @size-change="pageSizeChange" @current-change="pageChange">
        <template slot="menuLeft">
          <el-button type="primary" icon="el-icon-plus" size="small" plain @click.stop="handleManualAdd">手动新建售后
          </el-button>
        </template>
        <template slot-scope="scope" slot="status">
          <el-tag :type="statusTagType(scope.row.status)" size="mini">
            {{ statusLabel(scope.row.status) }}
          </el-tag>
        </template>
        <template slot-scope="scope" slot="menu">
          <div class="menu-actions">
            <el-button type="text" icon="el-icon-view" size="small" plain @click.stop="handleDetail(scope.row)">详情
            </el-button>
            <el-button type="text" icon="el-icon-tickets" size="small" plain @click.stop="toViewOrder(scope.row)">工单
            </el-button>
            <el-button type="text" icon="el-icon-circle-check" size="small" plain
              @click.stop="handleAssign(scope.row)">指派
            </el-button>
            <!-- 已完成订单可查看评价（与售后订单管理一致） -->
            <el-button v-if="scope.row.status === 'COMPLETE'" type="text" icon="el-icon-view" size="small" plain
              @click.stop="handleEvaluateView(scope.row)">评价</el-button>
            <el-button type="text" icon="el-icon-delete" size="small" plain v-if="scope.row.status !== 'CANCELLED'"
              @click.stop="handleCancel(scope.row)">作废
            </el-button>
          </div>
        </template>
      </avue-crud>
    </basic-container>

    <!-- 售后订单详情（通用组件，内含查看主订单详情入口） -->
    <detail-dialog :visible.sync="detailVisible" :after-sale-id="detailId" />

    <!-- 服务工单（含实际用料清单，待终审状态可在弹窗内通过/拒绝） -->
    <view-order :visibleOrder.sync="viewOrderVisible" :orderId="viewOrderId" :declarationInfo="viewOrderRow"
      @refresh="handleList" />

    <!-- 查看评价：复用售后订单管理（/work/afterSales）的评价弹窗 -->
    <evaluate-view-order :visibleOrder.sync="evaluateVisible" :orderId="evaluateOrderId" :orderType="evaluateOrderType"
      :declarationInfo="evaluateRow" :evaluateInfo="true" />

    <!-- 作废售后订单 -->
    <el-dialog title="作废售后订单" :visible.sync="cancelVisible" width="480px" append-to-body :close-on-click-modal="false">
      <el-form :model="cancelForm" :rules="cancelRules" ref="cancelForm" label-width="110px">
        <el-form-item label="作废原因" prop="cancelReason">
          <el-input type="textarea" :rows="3" v-model="cancelForm.cancelReason" maxlength="200" show-word-limit
            placeholder="请输入作废原因（不少于5个字）"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="cancelLoading" @click="submitCancel">确定作废</el-button>
      </span>
    </el-dialog>

    <!-- 指派工程师 -->
    <el-dialog title="指派工程师" :visible.sync="assignVisible" width="520px" append-to-body :close-on-click-modal="false">
      <div class="assign-info">
        <el-row :gutter="12">
          <el-col :span="12">
            <span class="detail-label">售后编号</span>
            <span class="detail-value">{{ assignRow.afterSaleNo || '-' }}</span>
          </el-col>
          <el-col :span="12">
            <span class="detail-label">客户姓名</span>
            <span class="detail-value">{{ assignRow.customName || '-' }}</span>
          </el-col>
          <el-col :span="12">
            <span class="detail-label">客户电话</span>
            <span class="detail-value">{{ assignRow.customMobile || '-' }}</span>
          </el-col>
          <el-col :span="12">
            <span class="detail-label">当前状态</span>
            <span class="detail-value">
              <el-tag :type="statusTagType(assignRow.status)" size="mini">{{ statusLabel(assignRow.status) }}</el-tag>
            </span>
          </el-col>
          <el-col :span="24" v-if="assignRow.engineerName">
            <span class="detail-label">当前工程师</span>
            <span class="detail-value">{{ assignRow.engineerName }}{{ assignRow.engineerMobile ? '（' + assignRow.engineerMobile + '）' : '' }}</span>
          </el-col>
        </el-row>
      </div>
      <el-form :model="assignForm" :rules="assignRules" ref="assignForm" label-width="90px">
        <el-form-item label="是否过保" prop="overinsuredFlag">
          <el-radio-group v-model="assignForm.overinsuredFlag">
            <el-radio label="YES">过保</el-radio>
            <el-radio label="NO">保内</el-radio>
            <el-radio label="PENDING">待工程师确认</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="工程师" prop="engineerId">
          <el-select v-model="assignForm.engineerId" placeholder="输入工程师姓名或手机号搜索" filterable remote reserve-keyword
            clearable :loading="assignSearchLoading" :remote-method="handleRemoteEngineer" style="width: 100%;">
            <el-option v-for="item in engineers" :key="item.id" :label="engineerLabel(item)" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="assignVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="assignLoading" @click="submitAssign">确认指派</el-button>
      </span>
    </el-dialog>

    <!-- 手动新建售后 -->
    <el-dialog title="手动新建售后单" :visible.sync="manualVisible" width="720px" append-to-body :close-on-click-modal="false">
      <el-form :model="manualForm" :rules="manualRules" ref="manualForm" label-width="110px">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="客户姓名" prop="customName">
              <el-input v-model="manualForm.customName" placeholder="请输入客户姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户电话" prop="customMobile">
              <el-input v-model="manualForm.customMobile" placeholder="请输入客户电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="客户地址" prop="customAddress">
          <div class="address-search-bar">
            <i class="el-icon-search address-search-icon"></i>
            <span class="address-search-label">搜索填充客户地址</span>
            <el-autocomplete
              v-model="addressKeyword"
              class="address-search-input"
              value-key="rawAddress"
              :fetch-suggestions="queryAddressSuggestions"
              placeholder="选中客户地址绑定主订单、一户一码"
              size="large"
              clearable
              @select="handleAddressSelect"
              @clear="handleAddressClear">
              <template slot-scope="{ item }">
                <div>{{ item.rawAddress }}</div>
                <div style="font-size: 12px; color: #909399;">编码：{{ item.code }}</div>
              </template>
            </el-autocomplete>
          </div>
          <div v-if="manualForm.houseCodeId" class="house-code-tag">
            <i class="el-icon-location-outline"></i>
            <span class="house-code-tag-text">已关联一户一码：{{ manualForm.houseCode }}</span>
            <el-button type="text" size="mini" @click="handleAddressClear">清空</el-button>
          </div>
          <el-input
            v-model="manualForm.customAddress"
            placeholder="请输入客户地址"
            :disabled="!!manualForm.houseCodeId"
            clearable
            @clear="handleAddressClear">
          </el-input>
        </el-form-item>
        <el-form-item label="指派工程师" prop="engineerId">
          <el-select v-model="manualForm.engineerId" placeholder="不选则进入待指派" filterable remote clearable
            :remote-method="handleRemoteEngineer" style="width: 100%;">
            <el-option v-for="item in engineers" :key="item.id" :label="engineerLabel(item)" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否过保" prop="overinsuredFlag">
          <el-radio-group v-model="manualForm.overinsuredFlag">
            <el-radio label="YES">过保</el-radio>
            <el-radio label="NO">保内</el-radio>
            <el-radio label="PENDING">待工程师确认</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="故障现象" prop="faultPhenomenon">
          <el-input type="textarea" :rows="3" v-model="manualForm.faultPhenomenon" placeholder="请输入故障现象描述"></el-input>
        </el-form-item>
        <el-form-item label="故障照片">
          <ImageUpload action="#" :multiple="true" :limit="5" @uploaded="handleManualPhotos"
            :uploaded-images="manualPhotos" />
        </el-form-item>
        <el-form-item label="故障视频">
          <videoAndFileUpload action="#" :multiple="false" :limit="1" @uploaded="handleManualVideo"
            :uploaded-images="manualVideos" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" :rows="2" v-model="manualForm.remarks" placeholder="选填"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="manualVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="manualLoading" @click="submitManual">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  afterSaleOption,
  AFTER_SALE_STATUS_DIC,
  statusTagType
} from '@/const/salesCloud/afterSaleOption';
import {
  getAfterSaleList,
  cancelAfterSale,
  createManual,
  assignAfterSale
} from '@/api/salesCloud/afterSale';
import { findUserList } from '@/api/work/projectService';
import { suggestByShop } from '@/api/salesCloud/houseCode';
import ImageUpload from '@/components/imageUpload/ImageUpload';
import videoAndFileUpload from '@/components/videoAndFileUpload/videoAndFileUpload';
import DetailDialog from './components/detailDialog.vue';
import ViewOrder from './components/viewOrder.vue';
// 查看评价弹窗：与售后订单管理（/work/afterSales）完全一致，直接复用
import EvaluateViewOrder from '@/views/work/afterSales/components/viewOrder.vue';

// 当前页面锁定业务线为防水
const BUSINESS_TYPE = 'WATERPROOF';

export default {
  name: 'afterSale',
  components: { ImageUpload, videoAndFileUpload, DetailDialog, ViewOrder, EvaluateViewOrder },
  data() {
    return {
      tableOption: afterSaleOption,
      tableData: [],
      tableLoading: false,
      searchParams: {},
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      // 详情
      detailVisible: false,
      detailId: '',
      // 工单查看
      viewOrderVisible: false,
      viewOrderId: '',
      viewOrderRow: {},
      // 评价查看（复用 /work/afterSales 评价弹窗）
      evaluateVisible: false,
      evaluateOrderId: '',
      evaluateOrderType: '',
      evaluateRow: {},
      // 作废
      cancelVisible: false,
      cancelLoading: false,
      cancelForm: {
        id: '',
        cancelReason: ''
      },
      cancelRules: {
        cancelReason: [
          { required: true, message: '请输入作废原因', trigger: 'blur' },
          { min: 5, message: '作废原因不能少于5个字', trigger: 'blur' }
        ]
      },
      // 指派工程师
      assignVisible: false,
      assignLoading: false,
      assignSearchLoading: false,
      assignRow: {},
      assignForm: {
        id: '',
        engineerId: '',
        overinsuredFlag: ''
      },
      assignRules: {
        engineerId: [{ required: true, message: '请选择工程师', trigger: 'change' }],
        overinsuredFlag: [{ required: true, message: '请选择是否过保', trigger: 'change' }]
      },
      // 手动新建
      manualVisible: false,
      manualLoading: false,
      manualForm: this.getInitialManualForm(),
      manualPhotos: [],
      manualVideos: [],
      engineers: [],
      remoteTimeout: null,
      addressRemoteTimeout: null,
      addressKeyword: '',
      manualRules: {
        customName: [{ required: true, message: '请输入客户姓名', trigger: 'blur' }],
        customMobile: [
          { required: true, message: '请输入客户电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        customAddress: [
          { required: true, validator: this.validateCustomAddress, trigger: 'blur' }
        ],
        faultPhenomenon: [{ required: true, message: '请输入故障现象', trigger: 'blur' }],
        overinsuredFlag: [{ required: true, message: '请选择是否过保', trigger: 'change' }]
      }
    };
  },
  created() {
    this.handleList();
  },
  methods: {
    statusTagType,
    getInitialManualForm() {
      return {
        businessType: BUSINESS_TYPE,
        customName: '',
        customMobile: '',
        customAddress: '',
        houseCodeId: '',
        houseCode: '',
        longitude: '',
        latitude: '',
        engineerId: '',
        overinsuredFlag: '',
        faultPhenomenon: '',
        remarks: ''
      };
    },
    // 统一解包：网关 data 可能是对象或 JSON 字符串
    parseData(res) {
      if (!res) return {};
      const data = res.data;
      if (typeof data === 'string') {
        try {
          return JSON.parse(data);
        } catch (e) {
          return {};
        }
      }
      return data || {};
    },
    statusLabel(val) {
      const item = AFTER_SALE_STATUS_DIC.find(i => i.value === val);
      return item ? item.label : (val || '-');
    },
    // 工程师下拉展示：姓名（手机号）
    // realName 中可能已包含手机号，避免重复拼接
    engineerLabel(item) {
      if (!item) return '';
      const name = (item.realName || '').trim();
      const mobile = (item.mobile || item.phone || '').trim();
      if (name && mobile) {
        // 姓名中已包含该手机号，直接返回姓名
        if (name.includes(mobile)) return name;
        return `${name}（${mobile}）`;
      }
      return name || mobile || (item.id != null ? String(item.id) : '');
    },
    // 组装列表查询参数（page 从 0 开始，锁定防水业务线）
    buildParams() {
      const params = {
        businessType: BUSINESS_TYPE,
        afterSaleNo: this.searchParams.afterSaleNo,
        status: this.searchParams.status,
        customMobile: this.searchParams.customMobile,
        page: this.page.currentPage - 1,
        size: this.page.pageSize
      };
      const range = this.searchParams.timeRange;
      if (Array.isArray(range) && range.length === 2) {
        params.startTime = range[0];
        params.endTime = range[1];
      }
      return params;
    },
    handleList() {
      this.tableLoading = true;
      getAfterSaleList(this.buildParams()).then(res => {
        const data = this.parseData(res);
        this.tableData = data.rows || [];
        this.page.total = data.total || 0;
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    searchChange(params, done) {
      this.searchParams = { ...params };
      this.page.currentPage = 1;
      this.handleList();
      done && done();
    },
    searchReset() {
      this.searchParams = {};
      this.page.currentPage = 1;
      this.handleList();
    },
    pageSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.page.currentPage = 1;
      this.handleList();
    },
    pageChange(currentPage) {
      this.page.currentPage = currentPage;
      this.handleList();
    },
    refreshChange() {
      this.handleList();
    },
    // 详情
    handleDetail(row) {
      this.detailId = row.id;
      this.detailVisible = true;
    },
    // 查看工单（含实际用料清单）
    toViewOrder(row) {
      this.viewOrderId = row.id;
      this.viewOrderRow = row;
      this.viewOrderVisible = true;
    },
    // 查看评价（已完成订单，与售后订单管理一致）
    handleEvaluateView(row) {
      this.evaluateOrderId = row.id;
      this.evaluateOrderType = row.type || '';
      this.evaluateRow = row;
      this.evaluateVisible = true;
    },
    // 作废
    handleCancel(row) {
      this.cancelForm = { id: row.id, cancelReason: '' };
      this.cancelVisible = true;
      this.$nextTick(() => {
        this.$refs.cancelForm && this.$refs.cancelForm.clearValidate();
      });
    },
    submitCancel() {
      this.$refs.cancelForm.validate(valid => {
        if (!valid) return;
        this.cancelLoading = true;
        cancelAfterSale({
          id: this.cancelForm.id,
          cancelReason: this.cancelForm.cancelReason
        }).then(res => {
          if (res && res.code == '200') {
            this.$message.success('作废成功');
            this.cancelVisible = false;
            this.handleList();
          } else {
            this.showErr(res);
          }
          this.cancelLoading = false;
        }).catch(err => {
          this.$message.error((err && err.message) || '作废失败');
          this.cancelLoading = false;
        });
      });
    },
    // 指派工程师
    handleAssign(row) {
      this.assignRow = row;
      // 已指派过工程师时默认回显，便于查看或直接改派
      this.assignForm = {
        id: row.id,
        engineerId: row.engineerId || '',
        overinsuredFlag: row.overinsuredFlag || ''
      };
      this.engineers = row.engineerId
        ? [{ id: row.engineerId, realName: row.engineerName || '', mobile: row.engineerMobile || '' }]
        : [];
      this.assignVisible = true;
      this.$nextTick(() => {
        this.$refs.assignForm && this.$refs.assignForm.clearValidate();
      });
    },
    submitAssign() {
      this.$refs.assignForm.validate(valid => {
        if (!valid) return;
        this.assignLoading = true;
        assignAfterSale({
          afterSaleId: this.assignForm.id,
          engineerId: this.assignForm.engineerId,
          overinsuredFlag: this.assignForm.overinsuredFlag
        }).then(res => {
          if (res && res.code == '200') {
            this.$message.success('指派成功');
            this.assignVisible = false;
            this.handleList();
          } else {
            this.showErr(res);
          }
          this.assignLoading = false;
        }).catch(err => {
          this.$message.error((err && err.message) || '指派失败');
          this.assignLoading = false;
        });
      });
    },
    // 手动新建
    handleManualAdd() {
      this.manualForm = this.getInitialManualForm();
      this.manualPhotos = [];
      this.manualVideos = [];
      this.engineers = [];
      this.addressKeyword = '';
      this.manualVisible = true;
      this.$nextTick(() => {
        this.$refs.manualForm && this.$refs.manualForm.clearValidate();
      });
    },
    handleManualPhotos(urls) {
      this.manualPhotos = urls;
    },
    handleManualVideo(urls) {
      this.manualVideos = urls;
    },
    handleRemoteEngineer(query) {
      if (!query) {
        this.engineers = [];
        return;
      }
      if (this.remoteTimeout) clearTimeout(this.remoteTimeout);
      this.remoteTimeout = setTimeout(() => {
        // eslint-disable-next-line no-control-regex
        const isChineseChar = /[^\x00-\xff]/.test(query);
        const isValidMobile = /^\d{2,}$/.test(query);
        if (isChineseChar || isValidMobile) {
          const params = { type: 'JOINS_ENGINEER', mobile: query };
          this.assignSearchLoading = true;
          findUserList(params).then(res => {
            if (res && res.code === '200') {
              this.engineers = this.parseData(res) || [];
            } else {
              this.showErr(res);
            }
            this.assignSearchLoading = false;
          }).catch(() => {
            this.assignSearchLoading = false;
          });
        }
      }, 200);
    },
    // 客户地址：远程搜索建议（200ms 防抖，至少 2 个字符）
    queryAddressSuggestions(queryString, callback) {
      if (!queryString || !queryString.trim() || queryString.trim().length < 2) {
        callback([]);
        return;
      }
      if (this.addressRemoteTimeout) clearTimeout(this.addressRemoteTimeout);
      this.addressRemoteTimeout = setTimeout(() => {
        suggestByShop(queryString.trim()).then(res => {
          if (!res || res.code !== '200') {
            callback([]);
            this.showErr(res);
            return;
          }
          // 接口 data 是 JSON 字符串，先解析
          let data = res.data;
          if (typeof data === 'string') {
            try { data = JSON.parse(data); } catch (e) { data = []; }
          }
          if (!Array.isArray(data)) data = [];
          callback(data.map(item => ({
            id: item.id,
            code: item.code,
            rawAddress: item.rawAddress,
            businessLines: item.businessLines,
            contactName: item.contactName,
            contactMobile: item.contactMobile,
            longitude: item.longitude,
            latitude: item.latitude,
            value: item.rawAddress
          })));
        }).catch(() => callback([]));
      }, 200);
    },
    // 选中地址候选项：写入客户地址、houseCodeId、houseCode（客户地址字段会被禁用）
    // 同时反显客户姓名、电话（仅当前为空时填充，避免覆盖用户已输入内容），并保存经纬度供提交
    handleAddressSelect(item) {
      if (!item) return;
      this.manualForm.customAddress = item.rawAddress || '';
      this.manualForm.houseCodeId = item.id || '';
      this.manualForm.houseCode = item.code || '';
      if (!this.manualForm.customName) {
        this.manualForm.customName = item.contactName || '';
      }
      if (!this.manualForm.customMobile) {
        this.manualForm.customMobile = item.contactMobile || '';
      }
      this.manualForm.longitude = item.longitude || '';
      this.manualForm.latitude = item.latitude || '';
      this.addressKeyword = item.rawAddress || '';
      this.$nextTick(() => {
        this.$refs.manualForm && this.$refs.manualForm.clearValidate(['customAddress']);
      });
    },
    // 客户地址校验：已关联一户一码时通过；否则要求非空
    validateCustomAddress(rule, value, callback) {
      if (this.manualForm.houseCodeId) {
        callback();
        return;
      }
      if (!value || !value.trim()) {
        callback(new Error('请输入客户地址'));
        return;
      }
      callback();
    },
    // 清空地址选择：客户地址、houseCodeId、houseCode、经纬度、搜索框输入同步清空
    handleAddressClear() {
      this.manualForm.customAddress = '';
      this.manualForm.houseCodeId = '';
      this.manualForm.houseCode = '';
      this.manualForm.longitude = '';
      this.manualForm.latitude = '';
      this.addressKeyword = '';
    },
    submitManual() {
      this.$refs.manualForm.validate(valid => {
        if (!valid) return;
        this.manualLoading = true;
        const payload = {
          businessType: BUSINESS_TYPE,
          customName: this.manualForm.customName,
          customMobile: this.manualForm.customMobile,
          customAddress: this.manualForm.customAddress,
          overinsuredFlag: this.manualForm.overinsuredFlag,
          faultPhenomenon: this.manualForm.faultPhenomenon,
          faultPhotos: this.manualPhotos.map(i => i.url).join(','),
          videoUrl: this.manualVideos.map(i => i.url).join(','),
          remarks: this.manualForm.remarks
        };
        if (this.manualForm.houseCodeId) {
          payload.houseCodeId = this.manualForm.houseCodeId;
          payload.houseCode = this.manualForm.houseCode;
        }
        if (this.manualForm.longitude || this.manualForm.latitude) {
          payload.longitude = this.manualForm.longitude;
          payload.latitude = this.manualForm.latitude;
        }
        if (this.manualForm.engineerId) {
          payload.engineerId = this.manualForm.engineerId;
        }
        createManual(payload).then(res => {
          if (res && res.code == '200') {
            this.$message.success('创建成功');
            this.manualVisible = false;
            this.page.currentPage = 1;
            this.handleList();
          } else {
            this.showErr(res);
          }
          this.manualLoading = false;
        }).catch(err => {
          this.$message.error((err && err.message) || '创建失败');
          this.manualLoading = false;
        });
      });
    },
    showErr(res) {
      this.$message({
        showClose: true,
        message: (res && res.message) || '操作失败',
        type: 'error'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.detail-label {
  color: #606266;
  font-size: 13px;
  min-width: 84px;
  margin-right: 6px;
}

.detail-value {
  color: #303133;
  font-size: 14px;
  flex: 1;
  min-width: 0;
}

.assign-info {
  background: #f4f8ff;
  border: 1px solid #d9ecff;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 18px;

  .el-col {
    line-height: 30px;
    display: flex;
    align-items: baseline;
  }
}

.menu-actions>.el-button {
  margin-right: 8px;
}

.crud-search-pad {
  padding-top: 12px;
}

.address-search-bar {
  display: flex;
  align-items: center;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 4px 10px;
  margin-bottom: 10px;

  .address-search-icon {
    color: #909399;
    font-size: 14px;
    margin-right: 6px;
  }

  .address-search-label {
    color: #606266;
    font-size: 13px;
    margin-right: 10px;
    white-space: nowrap;
  }

  .address-search-input {
    flex: 1;

    &::v-deep .el-input__inner {
      border: none;
      background: transparent;
      padding: 0 10px;
      height: 28px;
      line-height: 28px;
    }
  }
}

.house-code-tag {
  display: flex;
  align-items: center;
  background: #f0f9ff;
  border: 1px solid #d9ecff;
  border-radius: 4px;
  padding: 6px 10px;
  margin-bottom: 8px;
  font-size: 13px;
  color: #606266;

  .el-icon-location-outline {
    color: #409eff;
    margin-right: 6px;
  }

  .house-code-tag-text {
    flex: 1;
  }
}
</style>
